var _g, _g2, _g3, _rect, _path, _rect2, _path2, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistencePullUps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 149,
    viewBox: "0 0 290 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9737)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 39,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7BB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1543 131.924L37.8466 129.462V101.154H50.1543V129.462L53.8466 131.924",
    stroke: "#24284E",
    strokeWidth: 7.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8457 86.3845V103.615H50.1534V86.3845",
    stroke: "#24284E",
    strokeWidth: 7.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3076 86.3845V103.615H47.6922V86.3845",
    stroke: "#24284E",
    strokeWidth: 7.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 60.5386L28.8294 72.9789C29.0861 76.83 30.8821 80.4156 33.8126 82.9274V82.9274C36.4154 85.1584 39.7305 86.3848 43.1587 86.3848H44.8413C48.2695 86.3848 51.5846 85.1584 54.1874 82.9274V82.9274C57.1179 80.4156 58.9139 76.83 59.1706 72.9789L60 60.5386",
    stroke: "#24284E",
    strokeWidth: 7.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9999,
    cy: 72.8465,
    r: 7.38462,
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3848 60.5381H68.6155",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3848 60.5381L19.3848 143",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6152 60.5381L68.6152 143",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 48.8457V53.7688",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5381 51.3072L43.9996 48.8457L46.4612 51.3072",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11322_9737)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 39,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7BB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.154 131.924L133.847 129.462V101.154H146.154V129.462L149.847 131.924",
    stroke: "#24284E",
    strokeWidth: 7.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.846 86.3845V103.615H146.153V86.3845",
    stroke: "#24284E",
    strokeWidth: 7.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.308 86.3845V103.615H143.692V86.3845",
    stroke: "#24284E",
    strokeWidth: 7.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 60.5386L124.829 72.9789C125.086 76.83 126.882 80.4156 129.813 82.9274V82.9274C132.415 85.1584 135.731 86.3848 139.159 86.3848H140.841C144.269 86.3848 147.585 85.1584 150.187 82.9274V82.9274C153.118 80.4156 154.914 76.83 155.171 72.9789L156 60.5386",
    stroke: "#24284E",
    strokeWidth: 7.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 72.8465,
    r: 7.38462,
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.385 60.5381H164.616",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.385 60.5381L115.385 143",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.615 60.5381L164.615 143",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 48.8457V53.7688",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.538 51.3072L140 48.8457L142.461 51.3072",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11322_9737)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 31,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F7BB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.692 147.154L228.308 144.077V108.692H243.692V144.077L248.308 147.154",
    stroke: "#24284E",
    strokeWidth: 9.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.308 90.2311V111.77H243.692V90.2311",
    stroke: "#24284E",
    strokeWidth: 9.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.385 90.2311V111.77H240.616V90.2311",
    stroke: "#24284E",
    strokeWidth: 9.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 57.9228L217.037 73.4732C217.358 78.287 219.603 82.769 223.266 85.9088V85.9088C226.519 88.6976 230.663 90.2305 234.948 90.2305H237.052C241.337 90.2305 245.481 88.6976 248.734 85.9088V85.9088C252.397 82.769 254.642 78.287 254.963 73.4732L256 57.9228",
    stroke: "#24284E",
    strokeWidth: 9.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 73.3079,
    r: 9.23077,
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.23 57.9229H266.769",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.23 57.9229L205.23 161",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.77 57.9229L266.77 161",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 43.3076V49.4615",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.923 46.3845L236 43.3076L239.077 46.3845",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.5 101L168.5 105L175.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 101L72.5 105L79.5 97",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 85,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 101,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 147,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 10,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 132.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 30.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.5,
    cy: 24.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 119.5,
    r: 1.5,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 140.5,
    r: 1.5,
    fill: "white"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 23.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 41.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192 14L203 26",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M269.5 12L260.5 24",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.5 118L192 132.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250 127L255.5 138",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9737"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 39,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11322_9737"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 39,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11322_9737"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 31,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistencePullUps);
export default __webpack_public_path__ + "static/media/persistence-pull-ups.a8663d9748440b3a68d888fd88a6646c.svg";
export { ForwardRef as ReactComponent };